var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-self-stretch"},[_c('div',{ref:"sticky",staticClass:"tw-h-full"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }